import constants from '../config';

/**
 * Resolve a card image path to a full URL.
 * - Absolute URLs (http/https) are returned as-is
 * - Local uploads (uploads/...) are served from our API domain
 * - Everything else (external API paths like images/cards/...) uses CARD_IMAGE_BASE
 */
export function resolveCardImage(imagePath) {
  if (!imagePath) return null;
  if (imagePath.indexOf('http') === 0) {
    // Replace localhost URLs with the configured DOMAIN so images work from mobile devices
    if (imagePath.indexOf('http://localhost') === 0) {
      return imagePath.replace(/http:\/\/localhost:\d+/, constants.DOMAIN);
    }
    return imagePath;
  }
  if (imagePath.indexOf('uploads/') === 0) return constants.DOMAIN + '/' + imagePath;
  return constants.CARD_IMAGE_BASE + imagePath;
}
